import { Screen } from '@rahtab/stack-navigator';
import { Button, Card, CardCaption, CardContainer, getSpacing, Text, TextInput } from '@rahtab/ui';
import { useNTSW } from 'hooks/useNTSW';
import { useViewer } from 'hooks/useViewer';
import React, { useEffect, useState } from 'react';
import { Linking, StyleSheet } from 'react-native';

const NTSWScreen: React.VFC = () => {
  const [otp, setOtp] = useState<string>('');
  const [roleId, setRoleId] = useState<string>('');
  const { data: viewer } = useViewer();
  const ntsw = useNTSW({ otp, roleId });
  const openNTSWRegistrationPage = () => {
    Linking.openURL('https://www.ntsw.ir/Registerfrm.aspx');
  };

  const openNTSWRegistrationGuide = () => {
    Linking.openURL('https://go.rahtab.com/JQYh7T');
  };

  useEffect(() => {
    if (viewer.ntswRoleId) setRoleId(viewer.ntswRoleId);
  }, [viewer.ntswRoleId]);

  return (
    <Screen
      style={styles.screen}
      title="سامانه جامع تجارت"
      renderMain={() => (
        <>
          <Card style={styles.cardMargin}>
            <CardContainer>
              <Text style={styles.descriptionText}>
                به منظور ایجاد امکان ثبت خودکار اطلاعات بارهای دریافتی در سامانه جامع تجارت، ضروری است که با مراجعه به
                این قسمت نسبت به درخواست دریافت کد اعتبارسنجی و ثبت آن اقدام نمایید. عدم ثبت کد اعتبارسنجی سامانه جامع
                تجارت در سامانه رهتاب منجر به محرومیت از امکان سفارش‌گذاری خواهد شد.
              </Text>
              <Button color="secondary" text="درخواست کد اعتبارسنجی سامانه جامع تجارت" onPress={ntsw.requestCode} />
              <Button
                style={styles.ntswRegistrationPageButton}
                variant="outlined"
                color="secondary"
                text="دریافت راهنمای ثبت‌نام در سامانه جامع تجارت"
                onPress={openNTSWRegistrationGuide}
              />
              <Button
                style={styles.ntswRegistrationPageButton}
                variant="outlined"
                color="secondary"
                text="برو به وبسایت سامانه جامع تجارت"
                onPress={openNTSWRegistrationPage}
              />
            </CardContainer>
          </Card>
          <Card>
            <CardCaption>
              <Text style={styles.captionText} color="primary" margin="none">
                ثبت کد اعتبارسنجی سامانه جامع تجارت
              </Text>
            </CardCaption>
            <CardContainer>
              <TextInput
                label="کد نقش"
                placeholder="کد نقش سامانه جامع تجارت را وارد نمایید."
                value={roleId}
                onChangeText={setRoleId}
              />
              <TextInput
                label="کد اعتبارسنجی"
                placeholder="کد اعتبارسنجی سامانه جامع تجارت را وارد نمایید."
                value={otp}
                onChangeText={setOtp}
              />
              <Button
                color="primary"
                text="ثبت اطلاعات"
                onPress={ntsw.submitCode}
                disabled={otp.length < 1 || roleId.length < 1}
              />
            </CardContainer>
          </Card>
        </>
      )}
    />
  );
};

export default NTSWScreen;

const styles = StyleSheet.create({
  screen: {
    padding: getSpacing(),
  },
  cardMargin: {
    marginBottom: getSpacing(),
  },
  descriptionText: {
    textAlign: 'justify',
  },
  ntswRegistrationPageButton: {
    marginTop: getSpacing(),
  },
  captionText: {
    alignSelf: 'center',
  },
});
